<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <FiltroSolicitacoes />

      <v-flex lg12 sm12 xs12 class="pt-0">
        <!-- Botões de exportação -->
        <div class="mb-3 d-flex flex-wrap">
          <GeneratePDF
            :itemsPerPage="table.paginate.size"
            :head="table.header"
            :title="'Solicitações'"
            :report-data="searchJSON"
            :disable="table?.total === 0"
            class="mb-2 mr-2"
          />
          <GenerateExcel
            :itemsPerPage="table.paginate.size"
            :head="table.header"
            :title="'Solicitações'"
            :report-data="searchJSON"
            :disable="table?.total === 0"
            class="mb-2"
          />
        </div>

        <v-data-table
          class="d-none d-sm-block"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageOptions: [5,10,50,table.total].sort((a,b)=>a-b).filter(v=>v!==0)
          }"
          @click:row="(item) => routDados(item)"
          show-select
          v-model="itemsSelectedsDesktop"
        >

          <template #item.lote="{ item }"><span>{{ item.lote }}</span></template>
          <template #item.cpf="{ item }"><span>{{ item.cpf }}</span></template>
          <template #item.situacao="{ item }"><span>{{ item.situacao }}</span></template>
          <template #item.tipoSolicitacao="{ item }"><span>{{ item.tipoSolicitacao }}</span></template>

          <template #item.motivo="{ item }">
            <span :title="item.motivo" class="d-inline-block text-truncate" style="max-width: 150px;">
              {{ item.motivo }}
            </span>
          </template>

          <template #item.acoes="{ item }">
            <a @click.stop="routDados(item)">
              <v-icon color="primary" text size="middle" title="Visualizar Dados">description</v-icon>
            </a>

            <a
              v-if="item.situacao === 'Lote Recebido pela Entidade Estudantil'"
              @click.stop="enviarCarteiraAluno(item)"
            >
              <v-icon color="primary" size="middle" title="Enviar Carteira para Aluno">arrow_forward</v-icon>
            </a>
          </template>
        </v-data-table>

        <!-- Cards mobile -->
        <div class="d-block d-sm-none">
          <v-card
            v-for="item in pagedItems"
            :key="item.id"
            outlined
            class="mb-2 pa-2 cursor-pointer"
            :ripple="false"
            @click="onCardClick(item, $event)"
          >
            <v-row align="center">
              <v-col cols="2" class="d-flex align-center">

                <v-checkbox
                  :input-value="itemsSelectedIds.includes(item.id)"
                  @change="val => toggleItemSelectionMobile(item.id, val)"
                  @click.native.stop
                  @mousedown.native.stop
                  @mouseup.native.stop
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>

              <v-col cols="10">
                <div class="caption">
                  Número: <span class="font-weight-bold" style="color: #1976d2">{{ item.numeroSolicitacao }}</span>
                </div>
                <div class="caption">Lote: {{ item.lote }}</div>
                <div class="caption">CPF: {{ item.cpf }}</div>
                <div class="caption">Status: {{ item.situacao }}</div>
                <div class="caption">Tipo: {{ item.tipoSolicitacao }}</div>
                <div class="caption text-truncate" style="max-width: 100%;">Motivo: {{ item.motivo }}</div>
              </v-col>
            </v-row>
          </v-card>

          <!-- Botão mobile -->
          <div class="d-flex justify-end mt-2" style="max-width: 100%;">
            <v-btn
              color="primary"
              :loading="loadingCarteira"
              @click="()=>{ if (getSelectedIds().length) enviarCarteiraAluno(null) }"
            >
              <v-icon>arrow_forward</v-icon>
              Enviar Carteiras
            </v-btn>
          </div>

          <!-- Paginação mobile -->
          <v-row class="justify-center mt-2 mb-2">
            <v-pagination
              v-model="mobilePage"
              :length="mobileTotalPages"
              :total-visible="2"
              @input="onMobilePageChange"
            ></v-pagination>
          </v-row>
        </div>

        <!-- Botão desktop -->
        <div class="d-none d-sm-flex justify-end mt-2" style="max-width: 100%;">
          <v-btn
            :loading="loadingCarteira"
            @click="()=>{ if (getSelectedIds().length) enviarCarteiraAluno(null) }"
          >
            <v-icon color="primary" size="middle">arrow_forward</v-icon>
            Enviar Carteiras aos Alunos
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- Dialog de confirmação -->
    <OpenDialogConfirmar
      :openDialog="openDialogConfirmarEnvio"
      message="Somente confirme o envio das Carteiras se realmente os alunos tiverem recebido as Carteiras."
      :onClose="onClose"
      :onClick="enviarCarteirasAluno"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FiltroSolicitacoes from "./FiltroSolicitacoes.vue";
import GenerateExcel from "@/components/GenerateExcel.vue";
import GeneratePDF from "@/components/GeneratePDF.vue";
import EntidadeService from "@/services/sie-pedidos/entidade.service";
import { router } from "@/router";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import OpenDialogConfirmar from "@/components/OpenDialogConfirmar.vue";
import AuthService from "@/services/sie-pedidos/auth.service";

const actions = mapActions('siePedidos', ['setTableContent', 'setTableIsLoading', 'setTableTotals', 'clearTable', 'setTablePagination']);
const state = mapState('siePedidos', ['table']);

export default {
  components: { OpenDialogConfirmar, FiltroSolicitacoes, GenerateExcel, GeneratePDF },

  data: () => ({
    pagination: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },

    mobilePage: 1,
    mobilePageSize: 5,

    itemsSelectedsDesktop: [],
    itemsSelectedIds: [],

    loading: false,
    loadingCarteira: false,
    openDialogConfirmarEnvio: false,
  }),

  computed: {
    ...state,

    mobileTotalPages() {
      return Math.max(1, Math.ceil(((this.table.content || []).length) / this.mobilePageSize));
    },

    pagedItems() {
      const start = (this.mobilePage - 1) * this.mobilePageSize;
      return (this.table.content || []).slice(start, start + this.mobilePageSize);
    }
  },

  mounted() {
    this.setTablePagination({
      ...this.table.paginate,
      page: 0,
      size: this.pagination.itemsPerPage,
      sortBy: "id",
      sortOrder: "ASC"
    });

    this.search();
  },

  watch: {
    pagination: {
      handler() {
        this.changePagination();
      },
      deep: true
    },

    itemsSelectedsDesktop: {
      handler(newVal) {
        const ids = (newVal || []).map(i => i.id);
        this.itemsSelectedIds = ids;
      },
      deep: true
    },

    'table.content': {
      handler() {
        const valid = this.itemsSelectedsDesktop.filter(sel =>
          this.table.content.some(i => i.id === sel.id)
        );
        this.itemsSelectedIds = valid.map(v => v.id);
        this.itemsSelectedsDesktop = [...valid];
      },
      deep: true
    }
  },

  destroyed() {
    this.clearTable();
  },

  methods: {
    routDados(item) {
      router.push(`/carteira-macrorregiao/entidade/solicitacoes/detalhamento/${item.id}`)
        .catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
    },

    onCardClick(item, event) {
      const tag = event?.target?.tagName || '';
      const interactive = ['INPUT', 'LABEL', 'BUTTON', 'A', 'SVG', 'PATH'];
      if (interactive.includes(tag)) return;

      let el = event && event.target;
      while (el && el !== event.currentTarget) {
        if (el.tagName && interactive.includes(el.tagName)) return;
        el = el.parentElement;
      }

      this.routDados(item);
    },

    toggleItemSelectionMobile(itemId, checked) {
      try {
        if (checked) {
          if (!this.itemsSelectedIds.includes(itemId)) {
            this.itemsSelectedIds = [...this.itemsSelectedIds, itemId];
          }
        } else {
          this.itemsSelectedIds = this.itemsSelectedIds.filter(id => id !== itemId);
        }
      } catch (e) {
        console.error('toggleItemSelectionMobile error', e);
      } finally {
        this.$nextTick(() => {});
      }
    },

    onMobilePageChange(page) {
      this.mobilePage = page;
    },

    changePagination() {
      const { id } = this.$route.params;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;

      let input = { ...this.table.paginate };
      if (Object.prototype.hasOwnProperty.call(this.$route.query, "situacaoId")) {
        input = { ...this.table.paginate, situacaoId: this.$route.query.situacaoId };
      }

      const sortByKey = sortBy?.length ? sortBy[0] : 'id';
      const sortOrder = sortDesc.length ? (sortDesc[0] ? 'DESC' : 'ASC') : 'ASC';

      const paginate = {
        ...input,
        entidadeId: id,
        page: page - 1,
        size: itemsPerPage,
        sortBy: sortBy?.[0] ?? "id",
        sortOrder: sortDesc?.[0] ? "DESC" : "ASC"
      };

      this.setTablePagination(paginate);
      this.search();
    },

    searchJSON() {
      return new Promise((resolve, reject) => {
        EntidadeService.getLista({ ...this.table.paginate, size: this.table.total, page: 0 }).subscribe(
          ({ result }) => {
            resolve(
              (result.data || []).map(i => ({
                numeroSolicitacao: i.numeroSolicitacao,
                lote: i.loteId,
                cpf: FunctionsCommuns.formatCPF(i.cpf),
                situacao: i.situacao,
                tipoSolicitacao: i.tipoSolicitacao,
                motivo: i.motivo,
                dataSolicitacao: FunctionsCommuns.formatBRDateHora(i.dataSolicitacao),
                id: i.id
              }))
            );
          },
          reject
        );
      });
    },

    search() {
      this.setTableIsLoading(true);
      EntidadeService.getLista(this.table.paginate).subscribe(
        ({ result }) => {
          this.setTableContent(result?.data || []);
          this.setTableTotals(result.totalElements || 0);
          this.setTableIsLoading(false);
        },
        () => this.setTableIsLoading(false)
      );
    },

    getSelectedIds() {
      return this.isMobileView()
        ? [...this.itemsSelectedIds]
        : (this.itemsSelectedsDesktop || []).map(i => i.id);
    },

    isMobileView() {
      return window.innerWidth < 600;
    },

    enviarCarteiraAluno(item) {
      if (item) {
        this.itemsSelectedIds = [item.id];
        this.itemsSelectedsDesktop = [item];
      }

      const ids = this.getSelectedIds();
      if (!ids.length) {
        AuthService.globalStore("error", "Por favor selecione ao menos uma solicitação");
        return;
      }

      const allValid = ids.every(id => {
        const found = this.table.content.find(i => i.id === id);
        return found?.situacao === 'Lote Recebido pela Entidade Estudantil';
      });

      if (!allValid) {
        AuthService.globalStore("error", "Por favor selecione apenas solicitações com status válido");
        return;
      }

      this.openDialogConfirmarEnvio = true;
    },

    onClose() {
      this.openDialogConfirmarEnvio = false;
    },

    enviarCarteirasAluno() {
      const ids = this.getSelectedIds();
      if (!ids.length) {
        AuthService.globalStore("error", "Nenhuma solicitação selecionada");
        return;
      }

      this.loadingCarteira = true;

      EntidadeService.enviarCarteiraAluno(ids).subscribe({
        next: () => {
          AuthService.globalStore("success", "Carteiras Enviadas!");
          this.search();
          this.itemsSelectedIds = [];
          this.itemsSelectedsDesktop = [];
          this.openDialogConfirmarEnvio = false;
        },
        error: (error) => {
          AuthService.globalStore("error", error?.response?.data?.message || "Erro ao enviar");
        }
      }).add(() => {
        this.loadingCarteira = false;
      });
    },

    ...actions
  }
};
</script>
